import * as React from "react";
import { Switch, Route, Redirect, withRouter, RouteComponentProps } from "react-router-dom";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { Layout } from "antd";
import { ApplicationState } from "src/store";
import { LOGIN_URL } from "src/common/constants";
import { User } from "src/store/authorization/types";
import { fetchUserInfo } from "src/store/authorization/actions";
import MsHeader from "./ms-header/MsHeader";
import MsSider from "./ms-sider/MsSider";
import MsPayList from "../ms-pay/MsPayList";
import UnAuth from "../ms-unauth/MsUnAuth";
import Tools from "src/utils/tools";
import "./MsLayout.scss";

interface PropsFromState {
  isLogin: boolean;
  userInfo: User;
}

interface PropsFromDispatch {
  getUserInfoDisp: typeof fetchUserInfo;
}

type AllProps = PropsFromState & PropsFromDispatch & RouteComponentProps;

class MsLayout extends React.Component<AllProps> {
  // 渲染前调用
  public componentWillMount() {
    this.props.getUserInfoDisp();
  }

  // 登出
  public onLogout = () => {
    Tools.delCookie("ms_member_token");
    Tools.delCookie("ms_cid");
    window.location.href = LOGIN_URL;
  }

  public render() {
    const { superAdmin, appAdmin, existCoop } = this.props.userInfo;
    return this.props.isLogin ? (
      <Layout className="ms-layout">
        {existCoop === -1
          ? <div className="entrying">正在进入系统...</div>
          : <div className="ms-layout-main">
              <MsHeader onLogout={ this.onLogout } name={ this.props.userInfo.cidName } />
              {existCoop && (superAdmin === 1 || appAdmin === 1)
                ? <Layout>
                    <MsSider />
                    <Layout className="layout-content">
                      <Layout.Content>
                        <Switch>
                          <Route exact={true} path="/" component={MsPayList} />
                          <Route exact={true} path="/ms-pay-list/" component={MsPayList} />
                          <Redirect to="/" />
                        </Switch>
                      </Layout.Content>
                    </Layout>
                  </Layout>
                : <Layout className="layout-content">
                    <Layout.Content>
                      <Switch>
                        <Route exact={true} path="/ms-no-auth/" component={UnAuth} />
                        <Redirect to="/ms-no-auth/" />
                      </Switch>
                    </Layout.Content>
                  </Layout>
              }
            </div>
        }
      </Layout>
    ) : location.href = LOGIN_URL;
  }
}

// 关联state到组件props
const mapStateToProps = ({ authorizationState }: ApplicationState) => ({
  isLogin: authorizationState.isLogin,
  userInfo: authorizationState.userInfo
})

// 关联dispatch到组件props
const mapDispatchToProps = (dispatch: Dispatch) => ({
  getUserInfoDisp: () => dispatch(fetchUserInfo()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MsLayout));



// WEBPACK FOOTER //
// ./src/components/ms-layout/MsLayout.tsx